import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { resetForm } from '../store/claimSlice';
import banner from '../assets/tpp-claims-banner.jpg';
import {
  Button,
  Typography,
  Box,
} from '@mui/material';
import Layout from '../components/Layout';

const Success: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <Layout>
      <div className="banner">
        <img src={banner} alt="TPP Claims Banner" />
        <div className="banner-content">
          <h1>File a Claim</h1>
          <h2>Tenant Protection Plan</h2>
          <p>Follow our easy-to-use claim process to submit your claim!</p>
        </div>
      </div>

      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="h4" gutterBottom sx={{ color: 'var(--secondary-color)' }}>
          Claim has been successfully submitted
        </Typography>
        <Typography variant="body1" paragraph>
          We will review and get back to you soon.
        </Typography>
        <Button
          variant="contained"
          onClick={() => {
            dispatch(resetForm());
            navigate('/');
          }}
          sx={{
            backgroundColor: 'var(--primary-color)',
            '&:hover': {
              backgroundColor: 'var(--primary-color)',
              opacity: 0.9
            }
          }}
        >
          Submit Another Claim
        </Button>
      </Box>
    </Layout>
  );
};

export default Success;

